// @flow
//eslint-disable-next-line
import React, { useState, useEffect } from 'react'
import { isMobile } from 'react-device-detect'

import { useSelector } from 'react-redux'
import { CONSTANTS, HELPER, CART_HELPER, HISTORY } from '../../../utils'
import { ScrollUpButton } from '../../../components'
import {
	AccountInfo,
	AppFooter,
	AppParentWrapper,
	BrowseStores,
	LanguageInfo,
	MerchantLogo,
	WebMenuWrapper,
	MobileMenuDropdown,
	MobileMenuWrapper,
} from '../../../containers'
import { About } from '../../Header'

function AppWrapper(props) {
	const { cart, config } = useSelector((state) => state)
	const { selected_category } = useSelector((state) => state.inventory)
	const { networkAvailable } = useSelector((state) => state.toast)
	const { cart_items } = cart
	const { browseStores, default_username, additional_details } = config
	const {
		showFooter,
		showBackIcon,
		showLangIcon,
		showCartIcon,
		showAccountDropdown,
		observeBackHistory,
	} = props
	const [showScroller, setShowScroller] = useState(false)

	const moveBackwards = () => {
		if (observeBackHistory) {
			if (!browseStores) {
				window.location = process.env.REACT_APP_BSECURE_CUSTOMER_APP_URL
			} else {
				HISTORY.goBack()
			}
		} else {
			window.location = process.env.REACT_APP_BSECURE_CUSTOMER_APP_URL
		}
	}

	useEffect(() => {
		if (selected_category?.id === 0 && isMobile) {
			setShowScroller(true)
		} else {
			setShowScroller(false)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selected_category])

	return (
		<>
			<div className={!networkAvailable ? 'noEvents' : ''}>
				<AppParentWrapper />
				<div className="mainWrap default">
					<header>
						<div className="container">
							<div className="row justify-content-between">
								<div className="col-5 headerLogo">
									{showBackIcon && isMobile && browseStores ? (
										<div className="back_icon" onClick={moveBackwards}>
											<i className="icons-icon-back"></i>
										</div>
									) : (
										''
									)}
									<div className="logo_One">
										<MerchantLogo imgClasses="header-brand-img" />
									</div>
								</div>
								<div className="d-flex order-lg-2 ml-auto">
									{showCartIcon && !!additional_details?.pages?.about && <About />}
									{showBackIcon && browseStores ? (
										<BrowseStores observeBackHistory={observeBackHistory} />
									) : (
										''
									)}
									{showLangIcon ? <LanguageInfo /> : ''}
									{showCartIcon &&
									!HELPER.isEmpty(cart_items) &&
									CART_HELPER.CART_DEVICE_TYPE() === CONSTANTS.DEVICE_TYPE.WEB ? (
										<WebMenuWrapper />
									) : (
										''
									)}
									{showCartIcon &&
									!HELPER.isEmpty(cart_items) &&
									CART_HELPER.CART_DEVICE_TYPE() === CONSTANTS.DEVICE_TYPE.MOBILE ? (
										<MobileMenuWrapper />
									) : (
										''
									)}
									{showAccountDropdown ? <AccountInfo username={default_username} /> : ''}
								</div>
							</div>
						</div>
					</header>
				</div>
				<div className="appMainWrapper">
					<div className="progressWrap">
						<div className="progressLine" style={{ width: '100%' }}></div>
					</div>
					{showCartIcon &&
					!HELPER.isEmpty(cart_items) &&
					CART_HELPER.CART_DEVICE_TYPE() === CONSTANTS.DEVICE_TYPE.MOBILE ? (
						<MobileMenuDropdown />
					) : (
						''
					)}
					{props.children}
					{showFooter ? <AppFooter /> : ''}
					{/* Back to top button */}
					{showScroller && <ScrollUpBottom cart_items={cart_items} />}
				</div>
			</div>
		</>
	)
}

export const ScrollUpBottom = (props) => {
	const { cart_items } = useSelector((state) => state.cart)
	return (
		<ScrollUpButton
			{...props}
			classes={'backToTop'}
			ToggledClasses={'show'}
			HiddenClasses={'hideBackToTop'}
			cartItemCount={cart_items.items}
		>
			<i className="icons-expand-less"></i>
		</ScrollUpButton>
	)
}

export default AppWrapper
